import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal } from "./Reveal";
import { IMG } from "../../data/site";
import { useLang } from "../../i18n/LanguageContext";

const About = () => {
  const { t } = useLang();
  const a = t.about;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="about" data-testid="about-section" className="bg-cream py-24 md:py-32">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 items-center gap-14 px-5 md:px-10 lg:grid-cols-2 lg:gap-20">
        <Reveal className="order-2 lg:order-1">
          <p className="overline text-gold">{a.overline}</p>
          <div className="mb-6 mt-3"><span className="gold-rule block" /></div>
          <h2 className="font-serif font-light text-ink text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
            {a.title}
          </h2>
          <div className="mt-8 space-y-5 text-clay leading-relaxed max-w-xl">
            <p>{a.p1}</p>
            <p>{a.p2}</p>
            <p>{a.p3}</p>
          </div>
          <div className="mt-10 flex gap-12">
            <div>
              <p className="font-serif text-5xl text-gold">{a.stat1}</p>
              <p className="overline text-ink/60 mt-1">{a.stat1Label}</p>
            </div>
            <div>
              <p className="font-serif text-5xl text-gold">{a.stat2}</p>
              <p className="overline text-ink/60 mt-1">{a.stat2Label}</p>
            </div>
          </div>
        </Reveal>

        <div className="order-1 lg:order-2 relative">
          <div className="spotlight overflow-hidden rounded-t-[180px] rounded-b-[8px]">
            <motion.img
              style={{ y: imgY, scale: 1.12 }}
              src={IMG.farmer}
              alt="Indonesian vanilla farmer holding fresh pods"
              className="h-[520px] w-full object-cover md:h-[620px]"
            />
          </div>
          <div className="absolute -bottom-6 -left-6 hidden h-24 w-24 border-l border-b border-gold md:block" />
        </div>
      </div>
    </section>
  );
};

export default About;
